import React from 'react'
import { Modal, Button } from 'react-bootstrap'

const ConfirmationModal = (props) => {
  const { close, results, handleCallback, isModalDialogOpen, title, txId, isFetching, content } = props

  return (
    <Modal show={isModalDialogOpen} onHide={() => close()}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ wordWrap: 'break-word' }}>{content}</Modal.Body>
      <Modal.Footer>
        {results ? (
          <Button onClick={() => close()} variant={'default'}>
            Close
          </Button>
        ) : (
          <div>
            <Button onClick={() => close()} variant={'default'}>
              Cancel
            </Button>{' '}
            <Button disabled={isFetching} variant='success' onClick={() => handleCallback(txId)}>
              Initiate Callback
            </Button>
          </div>
        )}
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmationModal
